import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=41269637"
import script from "./RichText.vue?vue&type=script&setup=true&lang=js"
export * from "./RichText.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RichText.vue?vue&type=style&index=0&id=41269637&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports